import type { CaptureRequest } from '../domain/liveEvidenceCapture'
import { supabase } from '../lib/supabase'

/** The `{ code, error }` envelope the capture edge functions answer a failure with. */
const readServerError = async (error: { message: string; context?: unknown }): Promise<string> => {
  const context = error.context
  if (context instanceof Response) {
    try {
      const body: unknown = await context.clone().json()
      if (typeof body === 'object' && body !== null && 'error' in body && typeof body.error === 'string') {
        return body.error
      }
    } catch {
      // Not JSON: fall back to the client's own message below.
    }
  }
  return error.message
}

/**
 * Invoke the capture edge function a request names, as the signed-in operator.
 *
 * `functions.invoke` sends the session's access token, which is what the
 * functions' `requireUser` verifies; the service role never leaves the backend.
 *
 * @throws with the server's error message when the function answers a failure.
 */
export const invokeCapture = async (request: CaptureRequest): Promise<void> => {
  // The response body is not read on success: the page refetches the record.
  const result: { error: { message: string; context?: unknown } | null } = await supabase.functions.invoke(request.functionName, {
    body: request.body,
  })

  if (result.error) {
    throw new Error(await readServerError(result.error))
  }
}
